import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
 const [user, setUser] = useState(null);
 const [loading, setLoading] = useState(true);

 const checkAuth = useCallback(async () =>{
 try {
 const { data } = await api.get("/auth/me");
 setUser(data);
 } catch {
 setUser(false);
 } finally {
 setLoading(false);
 }
 }, []);

 useEffect(() =>{
 // Skip /me check while OAuth callback processes session_id
 if (window.location.hash?.includes("session_id=")) {
 setLoading(false);
 return;
 }
 checkAuth();
 }, [checkAuth]);

 const logout = async () =>{
 try {
 await api.post("/auth/logout");
 } catch {}
 setUser(false);
 window.location.href = "/login";
 };

 return (<AuthContext.Provider value={{ user, setUser, loading, logout, checkAuth }}>{children}</AuthContext.Provider>);
}

export const useAuth = () =>useContext(AuthContext);
